module.exports = __webpack_public_path__ + "static/img/table_no_data.519c96e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sources/table_no_data.png
// module id = clN1
// module chunks = 96